import { PlugCharging, Target, ShieldCheck } from "@phosphor-icons/react";

const STEPS = [
  {
    n: "01",
    icon: PlugCharging,
    title: "Charge",
    body: "Plug in via USB-C. Full charge in under 3 hours.",
  },
  {
    n: "02",
    icon: Target,
    title: "Set your temperature",
    body: "Dial in your exact target between 2\u20138\u00b0C on the digital display.",
  },
  {
    n: "03",
    icon: ShieldCheck,
    title: "Store with confidence",
    body: "Drop in your vials \u2014 CryoVault holds the cold chain 24/7.",
  },
];

export default function QualityControl() {
  return (
    <section
      id="quality"
      data-testid="quality-control"
      className="py-14 sm:py-20 bg-cool-white"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="overline text-cyan-brand" data-testid="howitworks-overline">
            How It Works
          </div>
          <h2
            data-testid="howitworks-title"
            className="font-display mt-4 text-4xl md:text-5xl lg:text-[54px] font-bold text-navy-deep tracking-tight leading-[1.05]"
          >
            Three steps. Total peace of mind.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {STEPS.map((s) => (
            <div
              key={s.n}
              data-testid={`howitworks-step-${s.n}`}
              className="reveal rounded-3xl bg-white border border-[#8A97A8]/25 p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_-24px_rgba(2,47,107,0.25)]"
            >
              <div className="font-mono-data text-teal-brand font-bold text-3xl tracking-tight tabular-nums">
                {s.n}
              </div>
              <div className="mt-5 h-12 w-12 rounded-2xl bg-navy-deep grid place-items-center text-white shadow-[0_10px_30px_-8px_rgba(2,47,107,0.55)]">
                <s.icon size={22} weight="regular" />
              </div>
              <h3 className="mt-6 font-display font-bold text-navy-deep text-xl">
                {s.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
